exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-row[data-v-41eac0da]{padding:12px 0 7px;border-top:1px solid #ddd}.vc-row.vc-row--last[data-v-41eac0da]{padding-bottom:11px;border-bottom:1px solid #ddd}.vc-row .vc-row__name[data-v-41eac0da]{line-height:28px}", ""]);

// exports
